import { LayoutPageSectionShell } from 'components/authorable/layout/LayoutPageSection/LayoutPageSection';
import { LayoutLeftThirdShell } from 'components/authorable/layout/LayoutLeftThird/LayoutLeftThird';
import AnnouncementFacets from 'components/helpers/AlgoliaSearch/NetworkResourceCenter/Announcement/AnnouncementFacets';
import AnnouncementStats from 'components/helpers/AlgoliaSearch/NetworkResourceCenter/Announcement/AnnouncementStats';
import { classnames } from 'tailwindcss-classnames';
import AnnouncementResults from 'components/helpers/AlgoliaSearch/NetworkResourceCenter/Announcement/AnnouncementResults';

export interface AnnouncementListingProps {
  fields?: {};
}

const AnnouncementListing = () => {
  return (
    <LayoutPageSectionShell theme="theme-white">
      <div
        className={classnames(
          'flex',
          'flex-col',
          'md:items-center',
          'justify-between',
          'w-full',
          'pb-6',
          'md:flex-row',
          'lg:pt-4',
          'lg:pb-2'
        )}
      >
        <AnnouncementStats />
      </div>
      <LayoutLeftThirdShell
        left={<AnnouncementFacets />}
        right={<AnnouncementResults />}
        isSearchPage
      />
    </LayoutPageSectionShell>
  );
};

export default AnnouncementListing;
